// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__gMZy7","Game__back":"Game_Game__back__PdpAl","Game__container":"Game_Game__container__1Ul3v","Game__container__row":"Game_Game__container__row__i5kui"};